(function () {
class $1bbdf1b27212aa2a$export$59dbc9ea2b6073f6 {
    constructor(searchBox, searchResultsCallback, searchErrorCallback){
        this.searchBox = undefined;
        this.searchResultsCallback = undefined;
        this.searchErrorCallback = undefined;
        // Event listener with debounced handler
        this.search = this.debounce((event)=>{
            const target = event.target;
            const value = target.value.trim();
            if (value.trim().length > 0) this.fetchData(value.trim());
            else if (this.searchResultsCallback) this.searchResultsCallback({
                tools: []
            });
        }, 500) // Adjust debounce time as necessary
        ;
        this.searchBox = searchBox;
        this.searchResultsCallback = searchResultsCallback;
        this.searchErrorCallback = searchErrorCallback;
        this.searchBox.addEventListener("input", this.search);
    }
    async fetchData(searchTerms) {
        try {
            const searchParams = new URLSearchParams({
                terms: searchTerms
            }).toString();
            const response = await fetch("/search/?" + searchParams, {
                method: "GET"
            });
            if (this.searchResultsCallback) {
                const json = await response.json();
                this.searchResultsCallback(json);
            }
        } catch (error) {
            const e = new Error(`Error fetching search data: ${error}`);
            if (this.searchErrorCallback) this.searchErrorCallback(e);
        }
    }
    // Debounce function
    debounce(func, timeout = 300) {
        let timer;
        return (...args)=>{
            clearTimeout(timer);
            timer = window.setTimeout(()=>{
                func.apply(this, args);
            }, timeout);
        };
    }
}


let $ce55e77697d7e2b8$var$searchManager = undefined;
const $ce55e77697d7e2b8$export$8e46d5c54043c803 = ()=>{
    let themeVal = localStorage.getItem("ngtheme");
    if (!themeVal) {
        themeVal = "ngblueorangelight";
        localStorage.setItem("ngtheme", themeVal);
    }
    const themeToggle = document.querySelector("input.swap-toggle");
    if (themeToggle) {
        if (themeVal == "ngblueorangedark") // @ts-ignore
        themeToggle.checked = true;
        else // @ts-ignore
        themeToggle.checked = false;
        themeToggle.addEventListener("change", (evt)=>{
            evt.preventDefault();
            // @ts-ignore
            const isChecked = themeToggle.checked;
            const html = document.querySelector("html");
            if (html) {
                if (isChecked) {
                    html.setAttribute("data-theme", "ngblueorangedark");
                    localStorage.setItem("ngtheme", "ngblueorangedark");
                } else {
                    html.setAttribute("data-theme", "ngblueorangelight");
                    localStorage.setItem("ngtheme", "ngblueorangelight");
                }
            }
        });
    }
    document.querySelector("html")?.setAttribute("data-theme", themeVal);
    const headerSearchBox = document.querySelector("#headersearchbox");
    if (!headerSearchBox) return;
    $ce55e77697d7e2b8$var$searchManager = new (0, $1bbdf1b27212aa2a$export$59dbc9ea2b6073f6)(headerSearchBox, (results)=>{
        const searchResultsList = document.querySelector("#searchresults ul");
        if (!searchResultsList) return;
        const baseUrl = document.querySelector("#baseurl")?.getAttribute("data-baseurl")?.replace("/placeholder", "");
        searchResultsList.innerHTML = "";
        if (results.tools.length > 0) results.tools.forEach((tool)=>{
            searchResultsList.innerHTML += `<li><a href=${baseUrl + tool.refname}>${tool.title}</a></li>`;
        });
        else searchResultsList.innerHTML += "<li>No results found</li>";
        document.querySelector("#searchresults")?.classList.add("dropdown-open");
    }, (error)=>{
        const searchResultsList = document.querySelector("#searchresults ul");
        if (!searchResultsList) return;
        searchResultsList.innerHTML = "";
        searchResultsList.innerHTML += "<li>Error fetching search data</li>";
    });
    document.querySelector("#searchresults")?.addEventListener("mouseleave", (evt)=>{
        document.querySelector("#searchresults")?.classList.remove("dropdown-open");
    });
};
// Menu logic
// Close menu when
// 1) another menu is opened
// 2) mouse leaves menu
// 3) Menu item is clicked - this is nav
//
document.querySelectorAll("details").forEach((details)=>{
    details.addEventListener("click", (evt)=>{
        document.querySelectorAll("details").forEach((d)=>{
            if (d !== details) d.removeAttribute("open");
        });
    });
});
// $("details").on('click', function() {
//     $("details").not(this).removeAttr('open');
// })
document.querySelectorAll("details ul").forEach((ul)=>{
    ul.addEventListener("mouseleave", (evt)=>{
        ul.closest("details")?.removeAttribute("open");
    });
});
// $("details ul").on('mouseleave', function() {
//     this.closest("details")?.removeAttribute('open');
// })
// $("details a").on('click', function() {
//     console.log("select");
//     this.closest("details")?.removeAttribute('open');
// })
// Mobile menu - open/close
// $("#mobile-menu-button").on('click', function() {
//     $("#mobile-menu").toggleClass("hidden");
//     $("#mobile-menu-block-open").toggleClass("block");
//     $("#mobile-menu-block-open").toggleClass("hidden");
//     $("#mobile-menu-block-closed").toggleClass("hidden");
//     $("#mobile-menu-block-closed").toggleClass("block");
//     $("#nav").toggleClass("open");
// })
// Mobile menu - close when a link is clicked
document.querySelector("#mobile-menu-button")?.addEventListener("click", (evt)=>{
    document.querySelector("#mobile-menu")?.classList.toggle("hidden");
    document.querySelector("#mobile-menu-block-open")?.classList.toggle("block");
    document.querySelector("#mobile-menu-block-open")?.classList.toggle("hidden");
    document.querySelector("#mobile-menu-block-closed")?.classList.toggle("hidden");
    document.querySelector("#mobile-menu-block-closed")?.classList.toggle("block");
    document.querySelector("#nav")?.classList.toggle("open");
});


document.addEventListener("DOMContentLoaded", ()=>{
    const env = document.querySelector('script[data-id="app"][data-environment]')?.getAttribute("data-environment") || "development";
    // if (['production', 'staging'].includes(env)) {
    //     // Sentry is in globals, loaded from CDN
    //     // @ts-ignore
    //     Sentry.init({
    //         environment: env,
    //     });
    // }
    (0, $ce55e77697d7e2b8$export$8e46d5c54043c803)();
});

})();
//# sourceMappingURL=app.js.map
